<template>
	<div v-if="cpage.isOpenFloat" class="floatbox flexStart">
		<!-- <el-button style="border-left: none; border-right: none" title="申请企业账号" size="mini" @click="handleApply"><i class="el-icon-user" style="font-size: 24px"></i> <span class="title">申请账号</span></el-button> -->

		<el-popover placement="left" title="" width="100" trigger="hover" content="18911620150">
			<div class="link-us-info">
				<p>服务时间：</p>
				<span>周一至周五</span>
				<span>9:00–17:00</span>
				<p>客服热线：</p>
				<span>18911620150</span>
				<p>客服微信：</p>
				<img :src="qrcodeUrl" alt="客服微信二维码" class="qrcode-img" />
			</div>
			<el-button size="mini" slot="reference"><i class="el-icon-phone-outline" style="font-size: 24px"></i><span class="title">联系我们</span></el-button>
		</el-popover>

		<el-button style="border-left: none; border-right: none; border-bottom: none" title="在线问题反馈" size="mini" @click="handleFeedback"
			><i class="el-icon-chat-dot-square" style="font-size: 24px"></i> <span class="title">在线反馈</span></el-button
		>

		<el-button style="border-left: none; border-right: none; margin-left: 0" title="正版查验查询" size="mini" @click="handleVerify"
			><i class="el-icon-search" style="font-size: 24px"></i> <span class="title">正版查验</span></el-button
		>

		<el-backtop :bottom="300">
			<div class="to-page-top">
				<i class="el-icon-upload2"></i>
			</div>
		</el-backtop>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		data() {
			return {
				qrcodeUrl: require('@/assets/images/kefu.png')
			};
		},
		computed: {
			...mapGetters('Cart', ['cartNum', 'allTotal']),
			...mapGetters(['cpage'])
		},
		methods: {
			handleVerify() {
				const targetRoute = this.$router.resolve({
					path: '/checker'
				});
				window.open(targetRoute.href, '_blank');
			},

			handleFeedback() {
				const q = this.$route.query;
				const query = {
					group: '在线问题反馈',
					id: 105,
					type: 'feedBack',
					title: '在线问题反馈'
				};
				// 从 /StandardsDet  /StandardsDoc  /StandardsPdf 三个页面跳转携带标准信息
				if (this.$route.name === 'StandardsDet' || this.$route.name === 'StandardsDoc' || this.$route.name === 'StandardsPdf') {
					query.standardId = q.standardId || q.id;
					query.standardName = q.standardName || q.title;
					query.standardCode = q.standardCode || q.code;
				}
				// 根据当前路由判断页面类型
				const pageTypes = { StandardsDet: '详情', StandardsPdf: 'pdf阅读', StandardsDoc: '智能文档阅读' };
				if (pageTypes[this.$route.name]) query.pageType = pageTypes[this.$route.name];
				const targetRoute = this.$router.resolve({
					path: '/info',
					query
				});
				window.open(targetRoute.href, '_blank');
			},

			handleApply() {
				const targetRoute = this.$router.resolve({
					path: '/applyAccount'
				});
				window.open(targetRoute.href, '_blank');
			}
		}
	};
</script>

<style lang="less" scoped>
	.floatbox {
		position: fixed;
		right: 0;
		bottom: 20%;
		-webkit-transform: translateY(50%);
		-moz-transform: translateY(50%);
		-ms-transform: translateY(50%);
		-o-transform: translateY(50%);
		transform: translateY(50%);
		-webkit-transition: -webkit-transform 0.5s ease;
		transition: -webkit-transform 0.5s ease;
		-o-transition: -o-transform 0.5s ease;
		-moz-transition: transform 0.5s ease, -moz-transform 0.5s ease;
		transition: transform 0.5s ease;
		transition: transform 0.5s ease, -webkit-transform 0.5s ease, -moz-transform 0.5s ease, -o-transform 0.5s ease;
		z-index: 100;
		flex-direction: column;
		background-color: #fff;
		border-radius: 8px 0 0 8px;
		box-shadow: -2px 0 30px 2px rgba(97, 105, 119, 0.18);
		> span {
			border-bottom: 1px solid #f5f5f5;
			button {
				// padding: 15px;
				font-size: 24px;
				border: none;
			}
			button:hover {
				color: #1474e2;
			}
		}
		> span:last-child {
			border-bottom: none;
		}

		.title {
			display: block;
			font-size: 12px;
			margin-top: 5px;
		}
	}
	/deep/ .el-backtop {
		position: initial;
		width: 100%;
		// height: 50px;
		box-shadow: none;
		font-size: 24px;
		border-radius: 0 0 4px 4px;
	}
	/deep/ .el-backtop:hover {
		color: #1474e2;
		background-color: #ecf5ff;
	}
	/deep/ .to-page-top[data-v-311c6350] {
		background-color: transparent;
		box-shadow: none;
		color: #686f83;
	}
	.cartinfo {
		padding: 10px;
	}
	.cartinfo strong {
		font-size: 14px;
		color: #ec2b2d;
	}

	.link-us-info {
		font-size: 13px;
		color: #606266;
		line-height: 22px;

		p {
			margin: 0;
			margin-top: 10px;
		}

		span {
			display: block;
			color: #000;
		}

		.qrcode-img {
			display: block;
			width: 80px;
			height: 80px;
			margin-top: 4px;
			border-radius: 4px;
			border: 1px solid #e8e8e8;
		}
	}
	.leftbox-cart {
		position: relative;
		.cart-tag {
			position: absolute;
			left: 30px;
			top: 10px;
			padding: 0 3px;
			border-radius: 20px;
			font-size: 10px;
			color: #ffffff;
			text-align: center;
			background-color: #ec2b2d;
			height: 14px;
			line-height: 14px;
			min-width: 14px;
			box-sizing: border-box;
		}
	}
</style>
